import React from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';

const ViewSubmissionsButton = ({ assignmentdata, className }) => {
  const history = useHistory();

  const handleViewSubmissions = () => {
    if (assignmentdata?.id) {
      history.push(`/tasks/${assignmentdata?.id}`);
    }
  };

  return (
    <ButtonContainer className={className}>
      <StyledButton onClick={handleViewSubmissions}>
        View Task Submissions
      </StyledButton>
    </ButtonContainer>
  );
};

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 40px;
`;

const StyledButton = styled.button`
  background: var(--color-purple-300, #7200E0);
  color: #ffffff;
  border: none;
  padding: 12px 24px;
  font-size: 14px;
  font-weight: 600;
  border-radius: 30px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: var(--font-family-ibm_plex_sans);
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 180px;

  &:hover {
    background: #5a00b3;
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    background: #cccccc;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }
`;

export default ViewSubmissionsButton;